import { cn } from "@utils/tw"
import { defineBlock, InnerBlocks } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Simple Table List",
  category: "layouts",
  description: "A simple table block",
  icon: "editor-alignleft",
  tags: ["#subpage", "#richtext"],
  flags: {
    contentWidth: true,
    needsPadding: 1,
  },
  blockStyles: [
    {
      label: "Justify",
      name: "default",
      isDefault: true,
    },
    {
      label: "Align Left",
      name: "align-left",
    },
  ],
}

export default defineBlock("content/table", (props) => {
  return (
    <div
      className={cn(
        "my-4 wp:p-2",
        props.blockStyle === "align-left"
          ? "sm:[&_.table-block-col]:w-1/2 text-left"
          : "sm:[&_.table-block-row]:justify-between sm:last:[&_.table-block-col]:text-right",
      )}
      data-mixpanel-block="Simple Table"
    >
      <InnerBlocks
        allowedBlocks={["content/table-row"]}
        appender={{ type: "default" }}
        defaultBlocks={new Array(3).fill(["content/table-row", {}])}
      />
    </div>
  )
})
